import PropTypes from 'prop-types';
import React, { useEffect } from "react"
import { useSelector } from "react-redux";
import { createSelector } from "reselect";
import { Routes, Route, Navigate, useNavigate } from "react-router-dom"
import { layoutTypes } from "./constants/layout";
// Import Routes all
import { authProtectedRoutes, publicRoutes } from "./routes";

// Import all middleware
import Authmiddleware from "./routes/route";

// layouts Format
import VerticalLayout from "./components/VerticalLayout/";
import HorizontalLayout from "./components/HorizontalLayout/";
import NonAuthLayout from "./components/NonAuthLayout";

// Import scss
import "./assets/scss/theme.scss";
import "toastr/build/toastr.min.css";
import Pages404 from "./pages/Utility/pages-404"
import { getUserRoleFromToken } from "./helpers/auth_token_helper"
import { StoreProvider } from "./contexts/StoreContext"


const getLayout = (layoutType) => {
  let Layout = VerticalLayout;
  switch (layoutType) {
    case layoutTypes.VERTICAL:
      Layout = VerticalLayout;
      break;
    case layoutTypes.HORIZONTAL:
      Layout = HorizontalLayout;
      break;
    default:
      break;
  }
  return Layout;
};

const RedirectLogic = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('authUser'); // ou ton système de stockage
    if (!token) {
      navigate('/login');
      return;
    }

    const roleUser = getUserRoleFromToken(token);
    if (roleUser === 'admin' || roleUser === 'manager') {
      navigate('/dashboard');
    } else {
      navigate('/sales');
    }
  }, [navigate]);

  return null;
}

const App = () => {

  const LayoutProperties = createSelector(
    (state) => state.Layout,
    (layout) => ({
      layoutType: layout.layoutType,
    })
  );

  const {
    layoutType
  } = useSelector(LayoutProperties);

  const Layout = getLayout(layoutType);

  return (
    <StoreProvider>
      <Routes>
        <Route path="/" element={<RedirectLogic />} />
        {publicRoutes.map((route, idx) => (
          <Route
            path={route.path}
            element={
              <NonAuthLayout>
                {route.component}
              </NonAuthLayout>
            }
            key={idx}
            exact={true}
          />
        ))}

        {authProtectedRoutes.map((route, idx) => (
          <Route
            path={route.path}
            element={
              <Authmiddleware requiredRoles={route.requiredRoles} requiresPublishing={route.requiresPublishing}>
                <Layout>{route.component}</Layout>
              </Authmiddleware>}
            key={idx}
            exact={true}
          />
        ))}
        <Route path="*" element={<Pages404 />} />
      </Routes>
    </StoreProvider>
  );
};

App.propTypes = {
  layout: PropTypes.any
};

export default App;
